import * as Api from '@ViewModels';

export const useIsDuplicateGroupingToggled = ({ request }: { request: Api.IBulkContactsRequest }) => {
	return (
		!!request.includeContactIds?.length ||
		!!request.filter.criteria.find(x => x.property === Api.ContactFilterCriteriaProperty.HasDuplicates)
	);
};
